"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FilterBar;
var _react = _interopRequireDefault(require("react"));
var _FilterSelect = _interopRequireDefault(require("./FilterSelect"));
var _ColumnFilter = _interopRequireDefault(require("./ColumnFilter"));
function FilterBar(props) {
  var prefixCls = props.prefixCls,
    columns = props.columns,
    onColumnFilterChange = props.onColumnFilterChange,
    onFilterSelectChange = props.onFilterSelectChange,
    onFilterSelectClear = props.onFilterSelectClear,
    onFilter = props.onFilter,
    dataSource = props.dataSource,
    filters = props.filters,
    columnFilters = props.columnFilters,
    placeholder = props.placeholder,
    multiple = props.multiple,
    getPopupContainer = props.getPopupContainer;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(prefixCls, "-filter-bar")
  }, /*#__PURE__*/_react["default"].createElement(_FilterSelect["default"], {
    prefixCls: prefixCls,
    placeholder: placeholder,
    columns: columns,
    dataSource: dataSource,
    onChange: onFilterSelectChange,
    onClear: onFilterSelectClear,
    onFilter: onFilter,
    filters: filters,
    columnFilters: columnFilters,
    getPopupContainer: getPopupContainer,
    multiple: multiple
  }), /*#__PURE__*/_react["default"].createElement(_ColumnFilter["default"], {
    prefixCls: prefixCls,
    columns: columns,
    onColumnFilterChange: onColumnFilterChange,
    getPopupContainer: getPopupContainer
  }));
}